import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles/InputLanguage.module.css";

const InputLanguage = ({ options, selectedOption }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState(selectedOption);
    const dropdownRef = useRef(null);
    const { i18n } = useTranslation();

    const detectedLang = selectedOption.split("-")[0];
    const availableLangs = options.map((option) => option.split("-")[0]);
    const isDetectedAvailable = availableLangs.includes(detectedLang);

    useEffect(() => {
        i18n.changeLanguage(isDetectedAvailable ? detectedLang : "en");
    }, [selectedOption]);

    useEffect(() => {
        setCurrentValue(detectedLang);
    }, [selectedOption]);

    const handleSelect = (option) => {
        setCurrentValue(option);
        i18n.changeLanguage(option);

        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className={`${styles.custom_dropdown}`} ref={dropdownRef}>
            <div
                className={`${styles.custom_dropdown_selected}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                {currentValue}
                <span
                    className={`${styles.custom_dropdown_arrow} ${
                        isOpen ? styles.open : ""
                    }`}
                ></span>
            </div>

            {isOpen && (
                <div className={`${styles.custom_dropdown_options}`}>
                    {options.map(
                        (option) =>
                            option.split("-")[0] !== currentValue && (
                                <div
                                    key={option}
                                    className={`${styles.custom_dropdown_option}`}
                                    onClick={() =>
                                        handleSelect(option.split("-")[0])
                                    }
                                >
                                    {option.split("-")[0]}
                                </div>
                            ),
                    )}
                </div>
            )}
        </div>
    );
};

export default InputLanguage;
